module.exports = __webpack_public_path__ + "files/f4b00b02eb7cc7b701fd5d46a5d76a2a.svg";


//////////////////
// WEBPACK FOOTER
// ./images/icons/excel.svg
// module id = 527
// module chunks = 27